import styled from 'styled-components';

import { Box } from '@sternum/styled-system';
import { ct } from '@sternum/web/utils/theme';

import { Colors } from '../theme/constants';

export const Container = styled(Box)`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  width: 100%;
  gap: 16px;
`;

export const StepperNumber = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  background-color: ${ct({ Dark: Colors.GreyLightest, Light: Colors.GreyLightest })};
  color: ${ct({ Dark: Colors.BrandBlue, Light: Colors.BrandBlue })};
  line-height: 18px;
  font-weight: 600;
  font-size: 12px;
  border-radius: 50%;
`;
